import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { AddQuestionTypeButtons } from "./AddQuestionTypeButtons";

export default function AddQuestion() {
    const { t } = useTranslation();
    return (
        <div className="p-2 flex flex-col justify-center items-center">
            <h2 className="flex items-center gap-2 text-sm mb-2 uppercase text-text-secondary">
                <FontAwesomeIcon icon={faPlus} />
                {t("question.add")}
            </h2>
            <AddQuestionTypeButtons />
        </div>
    );
}
